import {
    all,
    call,
    put,
    select,
    takeLatest,
    take,
    delay,
} from 'redux-saga/effects';
import { getApiSettings } from './api';
import { request } from '@vfde-fe/sails_core';

import {
    HAND_OVER_TO_AGENT,
    REFRESH_WEBCHAT,
} from './constants';
import {
    refreshWebchatFailed,
    refreshWebchatSuccess,
} from './actions';

import {
    RefreshWebchatConfig,
} from './api';

import getApiPath from 'Helper/getApiPath';

import {
    selectWebchatConfigUserId,
    selectWebchatConfigAlias,
    selectWebchatConfigSecureKey,
    selectWebchatConfigChatId,
} from 'Container/InitWebchat/selector';

import {
    selectWebchatNextPosition,
} from 'Container/Refresh/selector';
import { TRACKING_WEBCHAT_ERROR_MESSAGE_NOT_AVAILBLE } from 'Container/Tracking/constants';
import { selectWebchatPath } from 'Container/Ui/selector';

import { renderAgentTakeover } from '../../components/iconText';
import { GET_WEBCHAT_SUCCESS } from 'Container/InitWebchat/constants';

/**
 * wait for init and then call fresh in certain interval, if chat has been ended break the loop
 */
export function* refreshWebchat () {

    // do start with refresh before getting webchat instance was successful
    yield take(GET_WEBCHAT_SUCCESS);

    while (true) {
        try {

            const [userId, alias, secureKey, chatId, nextPosition, webchatPath] =
            yield all ([
                select(selectWebchatConfigUserId()),
                select(selectWebchatConfigAlias()),
                select(selectWebchatConfigSecureKey()),
                select(selectWebchatConfigChatId()),
                select(selectWebchatNextPosition()),
                select(selectWebchatPath()),
            ]);

            const data: RefreshWebchatConfig = {
                userId: userId,
                alias: alias,
                secureKey: secureKey,
                nextPosition: nextPosition,
            };

            const apiSettings = getApiSettings(data);

            const apiPath = getApiPath(chatId, 'refresh', webchatPath);

            const response = yield call(request, apiPath, apiSettings);

            // create and yield a dispatch Effect
            yield put(refreshWebchatSuccess(response.body));

            if (response.body.chatEnded) {
                break;
            }

            yield delay(1500);

        }
        catch (error) {
            yield put(refreshWebchatFailed(true, error?.res?.status || TRACKING_WEBCHAT_ERROR_MESSAGE_NOT_AVAILBLE));
        }
    }

}

/**
 * render Agent Takeover
 */
 export function* agentTakover () {
    yield call(renderAgentTakeover);
}

/**
 *  sendMessageSaga
 */
export default function* refreshWebchatSaga () {
    yield takeLatest(REFRESH_WEBCHAT, refreshWebchat);
    yield takeLatest(HAND_OVER_TO_AGENT, agentTakover);
}
